export const WEEKDAYS = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

export const MONTH_NAMES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const normalizeDaysToAdd = (value) => {
  if (value === null || value === undefined || value === '') return 0;

  const parsedValue = Number(value);

  if (Number.isNaN(parsedValue)) return 0;

  return parsedValue;
};

export const toDateKey = (timestamp) => {
  if (!timestamp) return null;

  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const buildDateKey = (year, month, day) =>
  `${year}-${`${month + 1}`.padStart(2, '0')}-${`${day}`.padStart(2, '0')}`;

export const groupByProjectedDate = (items) =>
  items.reduce((acc, item) => {
    const key = toDateKey(item.projectedDate);

    if (!key) return acc;

    if (!acc[key]) acc[key] = [];

    acc[key].push(item);

    return acc;
  }, {});

export const getMonthMatrix = (year, month) => {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const daysInMonth = lastDay.getDate();
  const firstWeekday = firstDay.getDay() === 0 ? 7 : firstDay.getDay();
  const previousMonthLastDay = new Date(year, month, 0).getDate();

  const cells = [];

  for (let i = firstWeekday - 1; i > 0; i -= 1) {
    const day = previousMonthLastDay - i + 1;
    const date = new Date(year, month - 1, day);

    cells.push({
      day,
      date,
      currentMonth: false,
      dateKey: buildDateKey(date.getFullYear(), date.getMonth(), day),
    });
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push({
      day,
      date: new Date(year, month, day),
      currentMonth: true,
      dateKey: buildDateKey(year, month, day),
    });
  }

  while (cells.length % 7 !== 0) {
    const nextIndex = cells.length - (firstWeekday - 1) - daysInMonth + 1;
    const date = new Date(year, month + 1, nextIndex);

    cells.push({
      day: nextIndex,
      date,
      currentMonth: false,
      dateKey: buildDateKey(date.getFullYear(), date.getMonth(), nextIndex),
    });
  }

  const weeks = [];

  for (let i = 0; i < cells.length; i += 7) {
    weeks.push(cells.slice(i, i + 7));
  }

  return weeks;
};

export const getAlertStatus = (item) => {
  if (item.alertStatus) return item.alertStatus;

  if (item.alertStatusValue === 0) return 'OVERDUE';
  if (item.alertStatusValue === 1) return 'DUE_SOON';
  if (item.alertStatusValue === 2) return 'IN_RANGE';
  if (item.alertStatusValue === 3) return 'EXTENDED';
  if (item.alertStatusValue === 4) return 'POSTPONE';

  return null;
};

export const getDayStatus = (items = []) => {
  if (items.some((item) => getAlertStatus(item) === 'OVERDUE')) {
    return 'OVERDUE';
  }

  if (items.some((item) => getAlertStatus(item) === 'POSTPONE')) {
    return 'POSTPONE';
  }

  if (items.some((item) => getAlertStatus(item) === 'EXTENDED')) {
    return 'EXTENDED';
  }

  if (items.some((item) => getAlertStatus(item) === 'DUE_SOON')) {
    return 'DUE_SOON';
  }

  if (items.some((item) => getAlertStatus(item) === 'IN_RANGE')) {
    return 'IN_RANGE';
  }

  return null;
};
export const getDayClassName = (status, isSelected, currentMonth) => {
  const classNames = ['pt-calendar-day'];

  if (!currentMonth) classNames.push('pt-calendar-day-muted');
  if (isSelected) classNames.push('pt-calendar-day-selected');

  if (status === 'OVERDUE') classNames.push('pt-calendar-day-overdue');
  if (status === 'DUE_SOON') classNames.push('pt-calendar-day-due-soon');
  if (status === 'EXTENDED') classNames.push('pt-calendar-day-extended');
  if (status === 'POSTPONE') classNames.push('pt-calendar-day-postpone');

  return classNames.join(' ');
};

export const formatDateTitle = (dateKey) => {
  if (!dateKey) return '-';

  const [year, month, day] = dateKey.split('-');

  return `${day}/${month}/${year}`;
};

export const getDayStatuses = (dayItems = []) => {
  const statuses = [];

  if (dayItems.some((item) => getAlertStatus(item) === 'OVERDUE')) {
    statuses.push('OVERDUE');
  }

  if (dayItems.some((item) => getAlertStatus(item) === 'DUE_SOON')) {
    statuses.push('DUE_SOON');
  }

  if (dayItems.some((item) => getAlertStatus(item) === 'IN_RANGE')) {
    statuses.push('IN_RANGE');
  }

  if (dayItems.some((item) => getAlertStatus(item) === 'EXTENDED')) {
    statuses.push('EXTENDED');
  }

  if (dayItems.some((item) => getAlertStatus(item) === 'POSTPONE')) {
    statuses.push('POSTPONE');
  }

  return statuses;
};

export const getDayVisualStatus = (dayItems = []) => {
  if (dayItems.some((item) => item.alertStatus === 'OVERDUE')) {
    return 'OVERDUE';
  }

  return null;
};
